import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  memberDetailActions,
  selectConnectEverywearStatusLoading,
} from 'features/member/reducer/memberDetailSlice';

import StatusDropdown from 'components/memberdetail/detail/connect/connectinformation/StatusDropdown';

import { connectEverywearStatusOption } from 'constants/member/connect';

import { Nullable } from 'types/common';
import { ConnectEverywearStatus } from 'types/member';
import { CommonSpinner } from '../common';

interface Props {
  userId: string;
  everyWearCreatorStatus: Nullable<ConnectEverywearStatus>;
}

const EveryWearStatusDropdown = ({ userId, everyWearCreatorStatus }: Props) => {
  const dispatch = useDispatch();
  const everywearStatusLoading = useSelector(selectConnectEverywearStatusLoading);

  const [currentEverywearStatus, setCurrentEverywearStatus] = useState<number>(
    everyWearCreatorStatus ?? ConnectEverywearStatus.INACTIVE,
  );

  const onChangeEverywearStatus = ({
    target: { value },
  }: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    const status = Number(value) === ConnectEverywearStatus.INACTIVE ? null : Number(value);
    setCurrentEverywearStatus(Number(value));
    dispatch(memberDetailActions.updateEverywearStatus({ userId, status }));
  };

  return (
    <>
      <StatusDropdown
        optionList={connectEverywearStatusOption}
        currentValue={currentEverywearStatus}
        onChangeValue={onChangeEverywearStatus}
      />
      {everywearStatusLoading && <CommonSpinner />}
    </>
  );
};

export default EveryWearStatusDropdown;
